export const GLOBAL_CONSTANTS = {
  WELCOME_MESSAGE: "Welcome!",
  LOGIN_MESSAGE: "Login to continue!",
  LOGIN_BUTTON: "Login",
  TUTORIALS: "Tutorials",
  FEEDBACK: "Feedback",
  QUICK_READS: "Quick Reads",
  INTRO_TO_TOOL: "Intro to the tool",
  EFFECTIVE_PROMPTING_GUIDE: "Effective prompting guide",
  FAQS: "FAQs",
  TUTORIAL_VIDEOS: "Tutorial Videos",
  BACK: 'Back',
  GLOBAL_MARCOM_LIBRARY: "Global Marcom Library",
  BRAND_GUIDELINES: "Brand Guidelines",
  LOGOS: "Logos"
};